/**
 * Справочники агента econ (ТЗ AI-FIN-2026 §7.3) — типы и метаданные для UI.
 *
 * Сами типы сущностей (EconObject, EconLicense, …) живут в API-слайсе
 * (`@shared/api`) — здесь только re-export для удобства и UI-метаданные
 * (подписи табов, описания справочников).
 */
export type {
  EconCashflowArticle,
  EconCostArticle,
  EconCostItem1c,
  EconCostItemLine,
  EconDictName,
  EconLicense,
  EconObject,
  EconProfitSplit,
  NewEconCashflowArticle,
  NewEconCostArticle,
  NewEconLicense,
  NewEconObject,
} from '@shared/api';

/** Метаданные справочника для UI (таб, заголовок, описание). */
export interface EconDictMeta {
  id: import('@shared/api').EconDictName;
  title: string;
  description: string;
}

/** Реестр справочников для табов экрана HandbooksView (ТЗ §7.3). */
export const ECON_DICTIONARIES: EconDictMeta[] = [
  {
    id: 'objects',
    title: 'Объекты',
    description:
      'Маппинг 1С↔план↔канон; «свой объект» — получатель внутреннего отпуска (Р-03/Р-04).',
  },
  {
    id: 'cost_articles',
    title: 'Статьи БДР',
    description: 'Статьи бюджета доходов/расходов с детерминированными правилами отнесения.',
  },
  {
    id: 'cost_items_1c',
    title: 'Статьи затрат 1С',
    description:
      'Статьи затрат из 1С и строки БДР, куда они идут: группа, строка, распределение и откуда берём сумму — из 1С, из Хронума или не берём.',
  },
  {
    id: 'cashflow_articles',
    title: 'Статьи ДДС',
    description: 'Статьи движения денежных средств (М4) с правилами классификации.',
  },
  {
    id: 'licenses',
    title: 'Лицензии',
    description:
      'Лицензии на добычу: лимиты, коэф. т↔м³ (Р-05), норматив потерь (Р-06), период действия.',
  },
  {
    id: 'unit_rates',
    title: 'Единичные расценки',
    description:
      'Эталонный справочник единичных расценок ПЭО для сверки БДР и импорта из ЛСР Сметчика.',
  },
  {
    id: 'profit_split',
    title: 'Распределение прибыли',
    description:
      'Коэффициенты распределения прибыли по объектам (Р-08); версионируемые — новая версия деактивирует прежнюю.',
  },
];
